import parse from 'html-react-parser'

import { CollapsibleItemArrowRight } from '@components/v2/collapsible-item-arrow-right'
import Head from 'next/head'
import { TextBase } from '@components/v2/TextBase'

import { SolarEnergy } from './components/solar-energy'

export const FaqFornecedores = () => {
  const FAQ = [
    {
      question:
        'O Portal Solar lida com todo o processo burocrático, como homologações e solicitações de acesso à rede elétrica?',
      answer:
        'Sim, a elaboração dos projetos, homologação junto à distribuidora e logística de entrega dos equipamentos são responsabilidades do Portal Solar.'
    },
    {
      question:
        'Qual é o tempo médio de instalação de um sistema de energia solar residencial?',
      answer:
        'O tempo de instalação varia conforme a quantidade de painéis solares do projeto. Um sistema com até 20 placas solares pode ser instalado em 1 dia.'
    },
    {
      question: 'O Portal Solar oferece garantias para os sistemas instalados?',
      answer:
        'Sim, o cliente do Portal Solar conta com 1 ano de garantia da instalação.'
    },
    {
      question:
        'O Portal Solar realiza uma avaliação prévia para determinar a viabilidade da instalação em minha propriedade?',
      answer:
        'Sim! O franqueado do Portal Solar realiza uma visita técnica e, por meio de um software exclusivo, determina a viabilidade da instalação. Com base nesses dados, o projeto é elaborado pelo nosso time de engenharia para atender as necessidades de consumo do cliente.'
    },
    {
      question:
        'Como posso acompanhar o desempenho do meu sistema solar após a instalação?',
      answer:
        'O cliente terá acesso a todas as informações do desempenho do sistema de energia solar por meio do aplicativo do Portal Solar. <br/> <br/> O Portal Solar possui um núcleo de monitoramento e operação remota dos sistemas de energia solar de todos os nossos clientes. Após a instalação, o nosso trabalho não acaba: monitoramos a produção de energia de todos os sistemas instalados para assegurar que estão produzindo a energia estimada durante o projeto e que não apresentam falhas. Isso nos permite agir de forma preventiva e evitar que o sistema pare de gerar energia.'
    }
  ]

  return (
    <div className="w-full pt-4 pb-10 bg-[#F9F9F9] lg:bg-white lg:pt-16">
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: FAQ.map(({ question, answer }) => ({
                '@type': 'Question',
                name: question,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: `<p>${answer}</p>`
                }
              }))
            })
          }}
        />
      </Head>

      <SolarEnergy />

      <div className="w-full m-auto">
        <h2 className="text-2xl text-v3-gray-500 text-center tracking-tight font-medium md:text-[1.75rem] md:text-v3-gray-900 md:text-left md:font-semibold md:uppercase">
          Perguntas Frequentes
        </h2>

        <ul className="mt-4 md:mt-10">
          {FAQ.map(({ question, answer }, index) => (
            <CollapsibleItemArrowRight
              key={index}
              question={question}
              className="mb-5"
            >
              <TextBase>{parse(answer)}</TextBase>
            </CollapsibleItemArrowRight>
          ))}
        </ul>
      </div>
    </div>
  )
}
